/* compare.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 24 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M14.9,11.3c-1.2,2.2-3.7,3.8-6.5,3.8C4.3,15.1,1,11.9,1,8s3.3-7.1,7.4-7.1c2.8,0,5.3,1.5,6.5,3.8H16
                C14.7,1.9,11.8,0,8.4,0C3.8,0,0,3.6,0,8s3.8,8,8.4,8c3.4,0,6.3-1.9,7.6-4.7H14.9z"/>
            <path class="foreground-gl" d="M15.6,0C12.2,0,9.3,1.9,8,4.7h1.1c1.2-2.2,3.7-3.8,6.5-3.8C19.7,0.9,23,4.1,23,8s-3.3,7.1-7.4,7.1
                c-2.8,0-5.3-1.5-6.5-3.8H8c1.3,2.8,4.2,4.7,7.6,4.7c4.6,0,8.4-3.6,8.4-8S20.2,0,15.6,0z"/>
            <polygon class="foreground-gl" points="21.4,7.9 14.5,5.4 15.3,7 8.7,7 9.5,5.4 2.6,7.9 9.5,10.4 8.7,8.7 15.3,8.7 14.5,10.4 "/>
            </svg>
         `
};
